class CartAnnouncementSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector(".cart-drawer-announcement__track");
    this.prevBtn = this.querySelector(".cart-drawer-announcement__arrow--prev");
    this.nextBtn = this.querySelector(".cart-drawer-announcement__arrow--next");
    this.items = this.querySelectorAll(".cart-drawer-announcement__item");
    this.currentIndex = 0;

    if (this.items.length > 1) {
      this.prevBtn.addEventListener("click", () => this.slide(-1));
      this.nextBtn.addEventListener("click", () => this.slide(1));
    }
  }

  slide(direction) {
    this.currentIndex += direction;

    // Loop around smoothly
    if (this.currentIndex < 0) {
      this.currentIndex = this.items.length - 1;
    } else if (this.currentIndex >= this.items.length) {
      this.currentIndex = 0;
    }

    // Move the track based on current index
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
  }
}

// Initialize the web component
if (!customElements.get("cart-announcement-slider")) {
  customElements.define("cart-announcement-slider", CartAnnouncementSlider);
}
